import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import OrganizationModel from "@/service/model/organization/OrganizationModel";
import { organizationService } from "@/service/api/OrganizationService";
import { communityService } from "@/service/api/CommunityService";
import CategoryModel from "@/service/model/community/CategoryModel";
import { CommunityCategoryType } from "@/enum/community/CommunityCategoryType";
import { OrganizationType } from "@/enum/organization/OrganizationType";

@Module({ namespaced: true, name: "organization" })
export default class Organization extends VuexModule {
  public organization = new OrganizationModel();
  public categories: CategoryModel[] = [];

  @Mutation
  public setOrganization(organization: OrganizationModel): void {
    this.organization = organization;
  }

  @Mutation
  public setCategory(): void {
    communityService
      .retrieveCommunityCategoryList(this.organization.id)
      .subscribe((categories: CategoryModel[]) => {
        this.categories = categories.sort((a, b) => a.order - b.order);
      });
  }

  @Action
  public initOrganization(handler?: (isSuccess: boolean) => void): void {
    const path: string[] = window.location.hostname.split(".");
    if (
      "localhost" !== path[0] &&
      !/^https:\/\/(www|stage|dev)?\.?codepresso\.kr$/.test(
        window.location.origin
      )
    ) {
      organizationService
        .retrieveByHostname(window.location.hostname.replace("www.", ""))
        .subscribe(
          (organization: OrganizationModel) => {
            this.context.commit("setOrganization", organization);
            this.context.commit("setCategory");
            if (handler) handler(true);

            this.context.commit("setHeaderTitle");
          },
          () => {
            this.context.commit("setCategory");
            if (handler) handler(false);
            // window.location.href = process.env.VUE_APP_MAIN_URL;
          }
        );
    } else {
      this.context.commit("setCategory");
    }
  }

  @Mutation
  public setHeaderTitle(): void {
    if (this.organization && this.organization.id === OrganizationType.Mobius) {
      document.title = "MOBIUS BOOTCAMP";
    } else {
      document.title = "프리미엄 IT 교육 서비스 - 코드프레소";
    }
  }

  public get isPrivateOrganizationPage(): boolean {
    return this.organization.id !== 1;
  }

  /**
   * 기업페이지 수강생 직접 결제 대상 여부.
   *
   * true 면 공개몰과 동일하게 장바구니/결제 플로우를 노출하고,
   * 티켓·자동 등록 기반 enrollment(OrganizationLearningStart)를 경유하지 않는다.
   *
   * 공개몰(id === 1)에서는 항상 false — 공개몰은 이 게터와 무관하게 기존 결제 경로를 탄다.
   * 서버가 필드를 내려주지 않으면 undefined 가 되므로 `=== true` 로 비교한다.
   */
  public get isDirectPaymentEnabled(): boolean {
    return (
      this.isPrivateOrganizationPage &&
      this.organization.isDirectPaymentEnabled === true
    );
  }

  public get isHyundaiMobis(): boolean {
    return this.organization.id === OrganizationType.HyundaiMobis;
  }

  public get isMobius(): boolean {
    return this.organization.id === OrganizationType.Mobius;
  }

  public get isHanjin(): boolean {
    return this.organization.id === OrganizationType.Hanjin;
  }

  public get isHyundaiCarLXP(): boolean {
    return this.organization.id === OrganizationType.HyundaiCarLXP;
  }

  public get providerIdText(): string {
    if (this.organization.id === 83 || this.organization.id === 14)
      return "사번";
    else return "고유번호";
  }

  public get isShowDepartmentInReport(): boolean {
    return this.organization.id === 14;
  }

  public get noticeCategoryId(): number | null {
    const index = this.categories.findIndex(
      category => category.categoryType === CommunityCategoryType.NOTICE
    );
    return index === -1 ? null : this.categories[index].id;
  }
}
